import UserSessionName from "./UserSessionName";
import UserSessionLink from "./UserSessionLink";


import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserSessionDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="UserSession-detail-title"
                    >
                        { label || t`User Session` }: <UserSessionName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="UserSession-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="UserSession-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="userId-label"><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="userId-value" >{ data.userId ? (<UserLink id={ data.userId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="userGroupId-label"><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="userGroupId-value" >{ data.userGroupId ? (<MembersGroupLink id={ data.userGroupId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="device-label"><Trans>Device</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="device-value" >{ data.device || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="createdAt-label"><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="createdAt-value" >{displayDateTime(data.createdAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="updatedAt-label"><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="updatedAt-value" >{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserSessionDetail;
